<template>
	<v-dialog
      v-model="show"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="#003441"
        dark
      >
        <v-card-text>
			&nbsp;
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>
<script>
	export default {
		props: ["show"],
	}
</script>